// Loại chứng từ của QLTS (1: Ghi tăng 2: Đánh giá lại 5: Hao mòn 6: Ghi giảm 9: Trích khấu hao)
export default {
  FAVoucherDepreciation: 5, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  FAVoucherIncreament: 1, // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 2, // Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 9, // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDecrement: 6, // Ghi giảm TSCĐ từ QLTS.VN  \
};
